import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name:'', email:'', phone:'', password:'', gender:'male', fitness_goal:'general_fitness', emergency_contact:'' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = k => e => setForm(p => ({...p, [k]: e.target.value}));

  const handleSubmit = async e => {
    e.preventDefault();
    if (form.password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    setError(''); setLoading(true);
    try {
      await register(form);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:24, background:'var(--bg)' }}>
      <div style={{ width:'100%', maxWidth:480 }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:44, marginBottom:10 }}>🏋️</div>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:24, fontWeight:700 }}>Join Fit to Fit</h1>
          <p style={{ color:'var(--text-secondary)', marginTop:4, fontSize:14 }}>Create your member account</p>
        </div>

        <div className="card" style={{ padding:28 }}>
          {error && <div style={{ background:'var(--danger-dim)', border:'1px solid rgba(239,68,68,.25)', borderRadius:'var(--radius)', padding:'10px 14px', marginBottom:18, fontSize:13, color:'var(--danger)' }}>{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="label">Full name *</label>
              <input className="input" placeholder="Ali Hassan" value={form.name} onChange={set('name')} required />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="label">Email address *</label>
                <input className="input" type="email" placeholder="ali@email.com" value={form.email} onChange={set('email')} required />
              </div>
              <div className="form-group">
                <label className="label">Phone number</label>
                <input className="input" type="tel" placeholder="0300-1234567" value={form.phone} onChange={set('phone')} />
              </div>
            </div>

            <div className="form-group">
              <label className="label">Password *</label>
              <input className="input" type="password" placeholder="At least 6 characters" value={form.password} onChange={set('password')} required />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="label">Gender</label>
                <select className="select" value={form.gender} onChange={set('gender')}>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label className="label">Fitness goal</label>
                <select className="select" value={form.fitness_goal} onChange={set('fitness_goal')}>
                  <option value="weight_loss">Weight loss</option>
                  <option value="muscle_gain">Muscle gain</option>
                  <option value="endurance">Endurance</option>
                  <option value="general_fitness">General fitness</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="label">Emergency contact (optional)</label>
              <input className="input" placeholder="Name — 0300-0000000" value={form.emergency_contact} onChange={set('emergency_contact')} />
            </div>

            <button className="btn-primary" type="submit" disabled={loading} style={{ width:'100%', justifyContent:'center', marginTop:6 }}>
              {loading ? 'Creating account…' : 'Create account'}
            </button>
          </form>

          <p style={{ textAlign:'center', marginTop:18, fontSize:13, color:'var(--text-secondary)' }}>
            Already registered? <Link to="/login" style={{ color:'var(--accent)', fontWeight:500 }}>Sign in</Link>
          </p>
        </div>

        <p style={{ textAlign:'center', marginTop:12, fontSize:12, color:'var(--text-muted)' }}>
          After registering, visit the gym desk to activate your membership.
        </p>
      </div>
    </div>
  );
}
